import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Label, Input, Button } from 'reactstrap';
import CanvasModal from '../components/Canvas/CanvasModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreatableSelect from 'react-select/creatable';
import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import * as utilities from '../utilities';

const EquipmentChecklist = (props) => {
  const [user, setUser] = useState(localStorage.getItem('user') != null ? localStorage.getItem('user') : '');
  const [email, setEmail] = useState(localStorage.getItem('email') != null ? localStorage.getItem('email') : '');

  const [isLoading, setIsLoading] = useState(true);
  const [config, setConfig] = useState(localStorage.getItem('config') != null ? JSON.parse(localStorage.getItem('config')) : []);
  const [dailyReportConfig, setDailyReportConfig] = useState(localStorage.getItem('dailyReportConfig') != null ? JSON.parse(localStorage.getItem('dailyReportConfig')) : []);
  const [stateVariables, setStateVariables] = useState(localStorage.getItem('stateVariables') != null ? JSON.parse(localStorage.getItem('stateVariables')) : {});

  // const [entries, setEntries] = useState(localStorage.getItem('entries') != null ? JSON.parse(localStorage.getItem('entries')) : []);
  const [isSaving, setIsSaving] = useState(false);

  const fetchDailyReportConfig = async () => {
    const response = await fetch(props.dailyReportConfigLink, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + utilities.getAccessToken()
      }
    })
    setIsLoading(false);
    if (response.ok) {
      const result = await response.json();

      const resultConfig = JSON.parse(result.config);
      let configObj = {};
      if (localStorage.getItem('dailyReportConfig') != null) {
        configObj = JSON.parse(localStorage.getItem('dailyReportConfig'));
      };
      configObj = { ...configObj, [props.config]: resultConfig };
      setDailyReportConfig(configObj);
      localStorage.setItem('dailyReportConfig', JSON.stringify(configObj));

      if (localStorage.getItem('stateVariables') == null) initializeStateVariables();
    } else {
      utilities.addToast('Unable to load latest configuration', 5, 'warning');
    }

  };

  const fetchConfig = async () => {
    const response = await fetch(props.configLink, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + utilities.getAccessToken()
      }
    })
    setIsLoading(false);
    if (response.ok) {
      const result = await response.json();

      const resultConfig = JSON.parse(result.config);
      let configObj = {};
      if (localStorage.getItem('config') != null) {
        configObj = JSON.parse(localStorage.getItem('config'));
      };
      configObj = { ...configObj, [props.config]: resultConfig };
      setConfig(configObj);
      localStorage.setItem('config', JSON.stringify(configObj));

      const resultFields = JSON.parse(result.fields);
      let fieldsObj = {};
      if (localStorage.getItem('fields') != null) {
        fieldsObj = JSON.parse(localStorage.getItem('fields'));
      };
      fieldsObj = { ...fieldsObj, [props.config]: resultFields };
      // setFields(fieldsObj);
      localStorage.setItem('fields', JSON.stringify(fieldsObj));

      if (localStorage.getItem('stateVariables') == null) initializeStateVariables();
    } else {
      utilities.addToast('Unable to load latest configuration', 5, 'warning');
    }

  };

  const generateRandomHex = () => {
    const randomHex = Math.floor(Math.random() * 0xFFFFFFFF).toString(16).toUpperCase();
    return randomHex.padStart(8, '0');
  }

  const initializeStateVariables = (force) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    const date = new Date().toLocaleDateString('en-CA', {
      timeZone: timeZone
    });
    if (stateVariables[props.config] == null || force) {
      const initialState = {
        Date: date,
        Time: time,
        EquipmentNo: '',
        JobName: '',
        Equipment1Name: 'Backup Horn',
        Equipment1YesNo: null,
        Equipment1Comment: '',
        Equipment2Name: 'Seatbelt',
        Equipment2YesNo: null,
        Equipment2Comment: '',
        Equipment3Name: 'Lights',
        Equipment3YesNo: null,
        Equipment3Comment: '',
        Equipment4Name: 'Fire Extinguisher',
        Equipment4YesNo: null,
        Equipment4Comment: '',
        Equipment5Name: 'Check for Visible Damage',
        Equipment5YesNo: null,
        Equipment5Comment: '',
        Equipment6Name: 'Brakes & Parking Brake',
        Equipment6YesNo: null,
        Equipment6Comment: '',
        Equipment7Name: 'Horn',
        Equipment7YesNo: null,
        Equipment7Comment: '',
        Equipment8Name: 'Leaks',
        Equipment8YesNo: null,
        Equipment8Comment: '',
        Equipment9Name: 'Tires',
        Equipment9YesNo: null,
        Equipment9Comment: '',
        Equipment10Name: '',
        Equipment10YesNo: null,
        Equipment10Comment: '',
        Equipment11Name: '',
        Equipment11YesNo: null,
        Equipment11Comment: '',
        Equipment12Name: '',
        Equipment12YesNo: null,
        Equipment12Comment: '',
        Equipment13Name: '',
        Equipment13YesNo: null,
        Equipment13Comment: '',
        Equipment14Name: '',
        Equipment14YesNo: null,
        Equipment14Comment: '',
        Equipment15Name: '',
        Equipment15YesNo: null,
        Equipment15Comment: '',
        Equipment16Name: '',
        Equipment16YesNo: null,
        Equipment16Comment: '',
        Signature: '',
        Name: '',
        Email: '',
        _TransactionCode: generateRandomHex(),
        _Timestamp: null,
        _Submitted: false
      };
      setStateVariables({ [props.config]: initialState });
      let obj = {};
      if (localStorage.getItem('stateVariables') != null) {
        obj = JSON.parse(localStorage.getItem('stateVariables'));
      };
      obj[props.config] = initialState;
      localStorage.setItem('stateVariables', JSON.stringify(obj))
    }
    setStateVariables(prev => ({
      ...prev,
      [props.config]: {
        ...prev[props.config],
        Time: time
      }
    }));
  };

  const handleInputChange = (key, e) => {
    let tempStateVariables = { ...stateVariables[props.config] };
    tempStateVariables[key] = e.target.value;
    setStateVariables((prev) => {
      let obj = { ...prev };
      obj[props.config][key] = e.target.value;
      obj[props.config] = { ...obj[props.config] }
      return {
        ...obj
      }
    }
    );
  };

  // const saveEntry = () => {
  //   let obj = {};
  //   if (localStorage.getItem('entries') != null) {
  //     obj = JSON.parse(localStorage.getItem('entries'));
  //   };
  //   if (obj[props.config] == null) obj[props.config] = [];
  //   stateVariables[props.config]['_Timestamp'] = (new Date().getTime()) / 1000;
  //   stateVariables[props.config]['_User'] = user;
  //   stateVariables[props.config]['_Email'] = email;
  //   obj[props.config].push(Object.entries(stateVariables[props.config]).reduce((acc, [key, val]) => {
  //     if ((val != null && val !== '') || String(key).substring(0, 1) === '_') acc[key] = val;
  //     return acc;
  //   }, {}));
  //   localStorage.setItem('entries', JSON.stringify(obj));
  //   setEntries(obj);
  //   initializeStateVariables(true);
  // }
  const saveEntry = async () => {
    setIsSaving(true);
    const submission = {
      ...stateVariables[props.config],
      _Timestamp: Date.now() / 1000,
      _User: user,
      _Email: email
    };

    try {
      const response = await fetch(props.submitLink, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + utilities.getAccessToken()
        },
        body: JSON.stringify(submission)
      });

      if (!response.ok) throw new Error('Submission failed');

      utilities.addToast('Submission successful', 5, 'success');
      initializeStateVariables(true); // Reset the form after successful submission
    } catch (error) {
      console.error(error);
      utilities.addToast('Submission failed, please try again', 5, 'danger');
    } finally {
      setIsSaving(false); // ✅ Always reset saving state here
    }
  };

  // const submitEntries = async () => {
  //   entries[props.config] != null && entries[props.config].filter(entry => !entry['_Submitted']).forEach(async entry => {
  //     const response = await fetch(props.submitLink, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': 'Bearer ' + utilities.getAccessToken()
  //       },
  //       body: JSON.stringify(entry)
  //     })
  //     if (response.ok) {
  //       utilities.addToast('Submission successful', 5, 'success');
  //       const result = await response.json();
  //       let obj = { ...entries };
  //       const entryIndex = obj[props.config].findIndex(entry => entry['_TransactionCode'] === result.transactionCode && !entry['_Submitted']);
  //       if (entryIndex > -1) {
  //         obj[props.config][entryIndex]['_Submitted'] = true;
  //         setEntries(obj);
  //         localStorage.setItem('entries', JSON.stringify(obj));
  //       }
  //     } else {
  //       utilities.addToast('Submission unsuccessful, however the data is being stored on your device and will be uploaded once connected.', 5, 'danger')
  //     }
  //   })
  // }

  const toggleQuestion = (key, isTrue) => {
    let tempStateVariables = { ...stateVariables[props.config] };
    tempStateVariables[`Equipment${key}YesNo`] = (tempStateVariables[`Equipment${key}YesNo`] === isTrue) ? null : isTrue;
    setStateVariables((prev) => {
      let obj = { ...prev };
      obj[props.config][`Equipment${key}YesNo`] = tempStateVariables[`Equipment${key}YesNo`];
      obj[props.config] = { ...obj[props.config] }
      return {
        ...obj
      }
    }
    );
  }

  const displayInputValue = (val) => {
    return (val != null) ? val : '';
  }

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '42px',
      height: '42px',
      borderRadius: 6,
      border: '0px solid #dee2e6',
      backgroundColor: '#fff',
      width: '200px'
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '42px', // Adjust height
      padding: '0 6px', // Adjust padding to align text if necessary
      color: '#000'
    }),
    input: (provided) => ({
      ...provided,
      padding: '0',
      margin: '0px', // Remove default margins
      color: 'black',
      // width: '120px',
      border: '0px solid #dee2e6',
      // backgroundColor: '#fff',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '42px', // Adjust the height of indicators (like dropdown arrow)
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '5px', // Adjust padding of the dropdown indicator icon
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: '5px', // Adjust padding of the clear indicator icon
    }),
    indicatorSeparator: () => ({
      display: 'none', // This hides the indicator separator
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the menu is above other elements
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 150, // Set a max height for the menu
      overflowY: 'auto',
      backgroundColor: '#ccc'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#000'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#ddd' : '#ccc',
      color: '#000',
      '&:hover': {
        backgroundColor: '#eee',
      }
    })
  };

  const customEquipmentNoSelectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '42px',
      height: '42px',
      borderRadius: 6,
      border: '1px solid #212529',
      backgroundColor: '#fff',
      width: '200px'
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '42px', // Adjust height
      padding: '0 6px', // Adjust padding to align text if necessary
      color: '#000'
    }),
    input: (provided) => ({
      ...provided,
      padding: '0',
      margin: '0px', // Remove default margins
      color: 'black',
      // width: '120px',
      border: '0px solid #dee2e6',
      // backgroundColor: '#fff',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '42px', // Adjust the height of indicators (like dropdown arrow)
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '5px', // Adjust padding of the dropdown indicator icon
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: '5px', // Adjust padding of the clear indicator icon
    }),
    indicatorSeparator: () => ({
      display: 'none', // This hides the indicator separator
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the menu is above other elements
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 150, // Set a max height for the menu
      overflowY: 'auto',
      backgroundColor: '#ccc'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#000'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#ddd' : '#ccc',
      color: '#000',
      '&:hover': {
        backgroundColor: '#eee',
      }
    })
  };

  // useEffect can be used for componentDidMount logic.
  useEffect(() => {
    fetchConfig();
    fetchDailyReportConfig();
  }, []); // empty dependency array ensures the effect runs only once after the initial render

  useEffect((e) => {
    initializeStateVariables(true);
  }, []);

  useEffect((e) => {
    localStorage.setItem('user', user)
  }, [user]);

  // useEffect((e) => {
  //   submitEntries();
  // }, [entries]);

  useEffect((e) => {
    localStorage.setItem('email', email)
  }, [email]);

  // useEffect((e) => {
  //   let obj = {};
  //   if (localStorage.getItem('stateVariables') != null) {
  //     obj = JSON.parse(localStorage.getItem('stateVariables'));
  //   };
  //   obj = { ...obj, ...stateVariables };
  //   localStorage.setItem('stateVariables', JSON.stringify(obj))
  // }, [stateVariables]);

  return (
    <>
      {stateVariables[props.config] != null && <div className='tablet px-2'>
        <Form>
          <Row className='m-0 p-0  align-items-center '>
            <Col xs={4} className='m-0 p-0 pe-3'>
              <Row>
                <Col className='m-0'>
                  <img id="logo" src={props.logo} alt={props.title} onClick={props.onLogoClick} />
                </Col>
              </Row>
              <Row>
                <Col xs={5} className='m-0 pe-1' id="userEmail">
                  <Input
                    bsSize='sm'
                    className='border-primary p-1'
                    id="user"
                    name="user"
                    placeholder="User"
                    value={user}
                    onChange={(e) => setUser(e.target.value)}
                  />
                </Col>
                <Col xs={5} className='m-0 pe-3 ps-0' id="userEmail">
                  <Input
                    bsSize='sm'
                    className='border-primary p-1'
                    id="email"
                    name="email"
                    placeholder='Email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Col>
                {/*
                {entries[props.config] != null && entries[props.config].filter(entry => !entry['_Submitted']).length > 0 &&
                  <Col xs={2} className='m-0 pe-3 ps-0 align-self-center'>
                    <div id="entriesCount">{entries[props.config].filter(entry => !entry['_Submitted']).length}</div>
                  </Col>} */}
              </Row>
            </Col>
            <Col className='m-0 p-0'>
              <Row className='row-cols-lg-auto g-3 align-items-center mt-2 mb-0'>

                <Col className='m-0 pr-0'>
                  <Label
                    for="Date">
                    Date
                  </Label>
                </Col>
                <Col className='m-0'>
                  <Input
                    // bsSize='lg'
                    className='border-dark'
                    type="date"
                    id="Date"
                    name="Date"
                    value={stateVariables[props.config].Date}
                    onChange={(e) => handleInputChange(e.target.name, e)}
                  />
                </Col>
                <Col className='m-0 pr-0'>
                  <Label
                    for="Time">
                    Time
                  </Label>
                </Col>
                <Col className=' m-0'>
                  <Input
                    // bsSize='lg'
                    className='border-dark'
                    type="time"
                    id="Time"
                    name="Time"
                    value={stateVariables[props.config].Time}
                    onChange={(e) => handleInputChange(e.target.name, e)}
                  />
                </Col>
                <Col className='m-0'>
                  <Label for="EquipmentNo">
                    Equip #
                  </Label>
                </Col>
                <Col className='m-0'>
                  {/* <Input
                    // bsSize='lg'
                    className='border-dark'
                    id="EquipmentNo"
                    name="EquipmentNo"
                    value={stateVariables[props.config].EquipmentNo}
                    onChange={(e) => handleInputChange(e.target.name, e)}
                  /> */}
                  <CreatableSelect
                    className={'border-dark'}
                    menuPlacement='auto'
                    menuPosition='fixed'
                    styles={customEquipmentNoSelectStyles}
                    name={`EquipmentNo`}
                    onChange={(e) => handleInputChange(`EquipmentNo`, { target: e })}
                    value={{
                      value: displayInputValue(stateVariables[props.config][`EquipmentNo`]),
                      label: displayInputValue(stateVariables[props.config][`EquipmentNo`])
                    }}
                    options={[
                      { value: '', label: 'SELECT' }, // This is the blank option
                      ...(dailyReportConfig[props.config]?.['LaborEquipmentNumbers'] || []).map(option => ({
                        value: option,
                        label: option
                      }))
                    ]}
                  />
                </Col>
                <Col className='m-0'>
                  <Label for="JobName">
                    Job Name
                  </Label>
                </Col>
                <Col className='flex-grow-1 m-0'>
                  <Input
                    // bsSize='lg'
                    className='border-dark'
                    id="JobName"
                    name="JobName"
                    value={stateVariables[props.config].JobName}
                    onChange={(e) => handleInputChange(e.target.name, e)}
                  />
                </Col>
              </Row>

            </Col>
          </Row>

          <Row className='align-items-start mt-2 mb-0 px-0 py-2 bg-primary'>
            <Col className='ps-5 mx-0 fs-5 fw-bold'>Equipment Checklist</Col>
          </Row>

          <Row className='align-items-start mt-0 mb-0 pb-2 bg-black text-white'>
            {[...Array(16).keys()].map(item => (
              <Col md={6} key={item} className='m-0 px-5 py-2'>
                <Row>
                  <Col className="col-lg-auto py-0">
                    {/* <Input
                      placeholder='Equipment Name'
                      className='border-dark'
                      id={`Equipment${item + 1}Name`}
                      name={`Equipment${item + 1}Name`}
                      value={stateVariables[props.config][`Equipment${item + 1}Name`]}
                      onChange={(e) => handleInputChange(e.target.name, e)}
                    /> */}
                    <CreatableSelect
                      placeholder="Equipment Name"
                      className={'border-dark'}
                      menuPlacement='auto'
                      menuPosition='fixed'
                      styles={customSelectStyles}
                      name={`Equipment${item + 1}Name`}
                      onChange={(e) => handleInputChange(`Equipment${item + 1}Name`, { target: e })}
                      value={{
                        value: displayInputValue(stateVariables[props.config][`Equipment${item + 1}Name`]),
                        label: displayInputValue(stateVariables[props.config][`Equipment${item + 1}Name`])
                      }}
                      options={[
                        { value: '', label: 'SELECT' }, // This is the blank option
                        ...(config[props.config]?.['EquipmentName'] || []).map(option => ({
                          value: option,
                          label: option
                        }))
                      ]}
                    />
                  </Col>
                  <Col className="col-lg-auto p-0">
                    <Button
                      onClick={() => toggleQuestion(item + 1, true)}
                      className='faButton text-light'
                      outline={stateVariables[props.config][`Equipment${item + 1}YesNo`] != null ? !stateVariables[props.config][`Equipment${item + 1}YesNo`] : null}
                      color={stateVariables[props.config][`Equipment${item + 1}YesNo`] != null ? (stateVariables[props.config][`Equipment${item + 1}YesNo`] ? "success" : null) : null}
                    >
                      <FontAwesomeIcon icon={faCheck} />
                    </Button>
                    <Button
                      onClick={() => toggleQuestion(item + 1, false)}
                      className='faButton ms-2 text-light'
                      outline={stateVariables[props.config][`Equipment${item + 1}YesNo`] != null ? stateVariables[props.config][`Equipment${item + 1}YesNo`] : null}
                      color={stateVariables[props.config][`Equipment${item + 1}YesNo`] != null ? (stateVariables[props.config][`Equipment${item + 1}YesNo`] ? null : "danger") : null}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </Button>
                  </Col>
                  <Col className="py-0">
                    <Input
                      placeholder='Comment'
                      className='border-dark'
                      id={`Equipment${item + 1}Comment`}
                      name={`Equipment${item + 1}Comment`}
                      value={stateVariables[props.config][`Equipment${item + 1}Comment`]}
                      onChange={(e) => handleInputChange(e.target.name, e)}
                    />
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>

          <Row className="bg-black text-white d-flex justify-content-center align-items-center">
            <Col
              className="d-flex justify-content-center align-items-center gap-3 m-0 pe-0 pb-2 position-relative"
              style={{ height: "100%" }}
            >
              {stateVariables[props.config].Signature !== '' &&
                <img className="signatureImage" src={stateVariables[props.config].Signature} alt="Signature" />}
              <CanvasModal
                arrkey="Signature"
                saveimage={setStateVariables}
                config={props.config}
              >
                <Input
                  className='border-primary bg-white text-white'
                  style={{ height: '62px', width: '474px' }}
                  id="Signature"
                  name="Signature"
                  readOnly={true}
                  placeholder="Signature"
                />
              </CanvasModal>
              {/* </Col>
            <Col className='align-items-end'> */}
              <Button
                color="success"
                className='ms-5 px-4 align-items-end'
                onClick={saveEntry}
                disabled={stateVariables[props.config].Signature === '' || isSaving}
              >
                Submit
              </Button>
            </Col>
          </Row>

        </Form >

      </div >}
    </>
  );
};

export default EquipmentChecklist;